import useMountEffect from '@restart/hooks/useMountEffect';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { RiUpload2Line } from 'react-icons/ri';
import { useDispatch, useStore } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import styles from './common.module.scss';

import actions from '@/actions';
import ConfirmSlider from '@/components/ui/ConfirmSlider';
import { getMission } from '@/helpers/Requester';
import useMissionCommand from '@/hooks/command/dji/useMissionCommand';
import { NotifierService as notifier } from '@/libs/Notifier';
import { executeDJICommand } from '@/utils/CommandUtils';

const cx = classNames.bind(styles);

const Panel = ({ data: robots }) => {
  const dispatch = useDispatch();
  const store = useStore();
  const [isProcessing, setProcessing] = useState(false);
  const missionCommand = useMissionCommand();

  useMountEffect(() => {
    const robot = robots[0];
    const mission = store.getState().missions[robot.id];

    // 미션 업로드 전 사전 검증: FC 다운로드 미션은 id 미존재
    if (!mission || !mission.id || mission.commands.length === 0) {
      notifier.error(`Please load the mission to the ${robot.name} robot first.`);
      dispatch(actions.command.resetActivePanels());
    }
  });

  //#region Process Functions
  const process = async (robot) => {
    const mission = store.getState().missions[robot.id];

    try {
      const { success, data } = await getMission(mission.id);
      if (!success) throw new Error();

      const { s3ObjectUrl, s3Checksum } = data;
      await executeDJICommand(robot, missionCommand.uploadSimulation(mission.id, s3ObjectUrl, s3Checksum));

      onSuccess(robot);
    } catch (error) {
      if (typeof error === 'object' && error?.data?.message) {
        console.debug(error.data.message);
      }
      onFailure(robot);
    }
  };
  //#endregion

  //#region Result Handlers
  // 성공 시 처리
  const onSuccess = (robot) => {
    notifier.success(`Mission uploaded successfully from ${robot.name}.`);
    setProcessing(false);
  };

  // 실패 시 처리
  const onFailure = (robot) => {
    notifier.error(`Failed to upload mission on ${robot.name}.`);
    setProcessing(false);
  };
  //#endregion

  useUpdateEffect(() => {
    if (!isProcessing) {
      dispatch(actions.command.resetActivePanels());
      return;
    }

    process(robots[0]);
  }, [isProcessing]);

  const doCommand = () => {
    // 처리 중 상태로 변경
    setProcessing(true);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('desc')}>Uploads planned mission to the aircraft</div>
      <ConfirmSlider
        width="100%"
        height={40}
        onConfirm={doCommand}
        isProcessing={isProcessing}
        labelStyle={{ fontSize: 12 }}
      />
    </div>
  );
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Upload (Simulation)';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = true;
Command.commanderOnly = true;
Command.Icon = RiUpload2Line;
Command.Panel = Panel;

export default Command;
